<section class="bg-gray-100 dark:bg-slate-800">
    <div class="w-full mx-auto">
        <div class="container mx-auto sm:px-0">
            <div class=" p-4 sm:p-6 lg:p-8">
                @if(view.site?.id !== 74 && view.site?.id !== 96) {
                <div class="mt-16 mb-8 flex flex-col items-center justify-center text-center">
                    <h4 class="text-base text-primry-600 font-semibold tracking-wide uppercase">Beyond the Ordinary</h4>
                    <p
                        class="mt-2 text-5xl lg:text-7xl font-semibold font-primary tracking-tight text-gray-900 dark:text-white">
                        XL Travel <span class="font-extralight">Holidays</span></p>
                    <img class="w-100" src="assets/xltravel/swoosh-01.svg" alt="xl underline">
                </div>
                <div class="text-center space-y-5">
                    <!-- <p class="mt-1 text-xl font-extrabold text-gray-900 sm:tracking-tight lg:text-2xl dark:text-white">Discover the world's most enchanting locales, from the crystalline shores of tropical paradises to the cobblestone streets of ancient cities.</p> -->
                    <!-- <p>
                            Embark on an unforgettable journey with XL Travel's exclusive Holiday Packages, where every detail has been meticulously crafted to deliver the ultimate travel experience. Our packages are designed with your desires in mind, offering unrivaled comfort, exotic destinations, and seamless itineraries that cater to both the avid adventurer and the relaxation seeker.
                        </p> -->
                    @if(!isLandingPage){
                    <p class="text-center" [innerHTML]="view.page?.content.rawContent"></p>
                    }
                    @if(isLandingPage){
                    <p class="text-center text-xl" [innerHTML]="content"></p>
                    }
                </div>
                }
            </div>

            <!-- <div class="flex flex-col sm:flex-row space-y-2.5 sm:space-y-0 sm:space-x-2.5 items-center justify-center my-6">
                <div class="flex max-w-sm rounded-xl bg-gradient-to-tr from-primary-500 to-accent-500 p-0.5 shadow-lg hover:transition-all delay-150 duration-300 ease-in-out">
                    <button [routerLink]="/leisure-travel'" class="flex-1 font-bold text-xl bg-white px-6 py-3 rounded-xl dark:bg-slate-900">Find Out More</button>
                </div>
            </div> -->
            <!-- <div class="container mx-auto mt-10 px-4">
                <div class="grid gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6">
                    @if(view.destinations) {
                        @for(item of view.destinations; track destination){
                            <div class="mb-3">
                                <a [routerLink]="[/destination', item.id, item.seo.alias]"
                                class="relative border-2 border-primary-500 rounded px-4 py-2 inline cursor-pointer text-2xl font-bold before:bg-primary-500 hover:rounded-b-none before:absolute before:-bottom-0 before:-left-0  before:block before:h-[4px] before:w-full before:origin-bottom-right before:scale-x-0 before:transition before:duration-300 before:ease-in-out hover:before:origin-bottom-left hover:before:scale-x-100">
                                {{ item.name }}
                              </a>
                            </div>
                        }
                    }
                </div> 
            </div>-->
            <!-- <div class="container mx-auto mt-10 px-4">
                <div class="flex flex-wrap justify-center">
                    @if(view.destinations) {
                        @for(item of view.destinations; track destination){
                            <div class="mb-3 m-2">
                            <a   [routerLink]="[/destination', item.id, item.seo.alias]"
                                class="relative w-40 border-2 border-primary-500 rounded px-4 py-2 inline cursor-pointer text-2xl font-bold before:bg-primary-500 hover:rounded-b-none before:absolute before:-bottom-0 before:-left-0 before:block before:h-[4px] before:w-full before:origin-bottom-right before:scale-x-0 before:transition before:duration-300 before:ease-in-out hover:before:origin-bottom-left hover:before:scale-x-100"
                            >
                                {{ item.name }}
                            </a>
                            </div>
                        }
                    }
                </div>
            </div> -->

            <div class="flex flex-wrap justify-center dark:bg-slate-800">
                <app-deals-type01></app-deals-type01>
            </div>
            <div
                class="flex flex-col sm:flex-row space-y-2.5 sm:space-y-0 sm:space-x-2.5 items-center justify-center ng-star-inserted mt-5 pb-10">
                <div
                    class="flex max-w-sm rounded-xl bg-gradient-to-tr from-primary-500 to-accent-500 p-0.5 shadow-lg hover:transition-all delay-150 duration-300 ease-in-out">
                    <a class="flex-1 font-bold text-xl bg-white px-6 py-3 rounded-xl dark:bg-slate-800"
                        [routerLink]="'/packages'">View all Packages</a>
                </div>
                <!-- <div  class="flex max-w-sm rounded-xl bg-gradient-to-tr from-primary-500 to-accent-500 p-0.5 shadow-lg hover:transition-all delay-150 duration-300 ease-in-out">
                    <a  class="flex-1 font-bold text-xl bg-white px-6 py-3 rounded-xl dark:bg-slate-800" routerLink="packages/black-friday-specials" >Black Friday Deals 🎉</a>
                </div> -->
            </div>
        </div>
    </div>
</section>



<div class="w-full border-b-2 border-primary-500 bg-white">
    <app-counters-type01></app-counters-type01>
</div>